import React from "react";
import { cn } from "../../lib/utils";

export const BentoGrid = ({ className, children }) => {
    return (
        <div
            className={cn(
                "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mx-auto",
                className
            )}
        >
            {children}
        </div>
    );
};

export const BentoGridItem = ({ className, header }) => {
    return (
        <div
            className={cn(
                "group overflow-hidden border border-[var(--line)] bg-[var(--surface)] hover:border-[var(--accent)] transition-colors duration-200",
                className
            )}
        >
            <div className="w-full h-full p-2 pb-4">{header}</div>
        </div>
    );
};
